import { useRef } from 'react';
import { Box, Popover, useTheme } from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import { ArrowDownIcon } from 'src/assets/icons/common/ArrowDownIcon';
import { useToggle } from 'src/hooks/useToggle';

type Props = {
  color: string;
  onChange: (color: string) => void;
};

export const AxisColorPicker = ({ color, onChange }: Props) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const { state: isOpen, onToggle } = useToggle();

  const theme = useTheme();
  const iconColor = theme.palette.grey[500];

  return (
    <Box>
      <Box ref={triggerRef} onClick={onToggle} sx={{ cursor: 'pointer' }}>
        <ArrowDownIcon stroke={iconColor} />
      </Box>
      <Popover
        open={isOpen}
        anchorEl={triggerRef.current}
        onClose={onToggle}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <HexColorPicker color={color} onChange={onChange} />
      </Popover>
    </Box>
  );
};
